import { buildPlanCatalog, type PlanCatalog, type PlanOption } from '@/lib/aihumanit-plan-registry';

export type { PlanOption, PlanCatalog };

export function getServerPlanCatalog(): PlanCatalog {
  return buildPlanCatalog();
}

export async function fetchPlanCatalog(): Promise<PlanCatalog> {
  const response = await fetch('/api/aihumanit/plans', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('Failed to load AIHumanIT plans');
  }
  return response.json() as Promise<PlanCatalog>;
}
